
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/people/[profile]",
      function () {
        return require("private-next-pages/people/[profile].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/people/[profile]"])
      });
    }
  